import axios from 'axios';

import { LocalStorage } from '@data/enums';

import { GetTimeTrackingReportParams, TimeTrackingReport } from './types';

// Self-contained call to the global time tracking report endpoint.
//
// We intentionally do NOT add this to the shared dy-frontend-http-repository
// package: that would require pushing a third repo and bumping the lockfile.
// Instead we reuse the exact same configuration the app already uses — the
// API base URL from the build-time env and the bearer access token from
// localStorage (the same key the shared repository instance is seeded with).
export const getTimeTrackingReport = async ({
    fromDate,
    toDate,
}: GetTimeTrackingReportParams): Promise<TimeTrackingReport> => {
    const baseURL = (process.env.API_BASE_URL ?? '').replace(/\/+$/, '');
    const accessToken = localStorage.getItem(LocalStorage.ACCESS_TOKEN);

    const params: { to_date: string; from_date?: string } = { to_date: toDate };
    if (fromDate) {
        params.from_date = fromDate;
    }

    const { data } = await axios.get(`${baseURL}/api/time-tracking/report`, {
        params,
        headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });

    // Endpoint returns a QueryCollectionOutput: { items: [...], paginator, cursor, sort },
    // extended with the pre-aggregated `sub_tasks` breakdown. Both default to empty, so a
    // backend that predates the breakdown simply yields a report with no second sheet.
    return {
        items: data?.items ?? [],
        sub_tasks: data?.sub_tasks ?? [],
    };
};
